import React from "react";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../hooks/useStore";
import {minuteToString} from "../../../../utils/helpers";

const ShiftScoreDetailModal = ({
    reportDate,
    fullname,
    tckn,
    cellPhone,
    companyName,
    subCompanyName,
    shiftStartTime,
    shiftEndTime,
    workTimeMinute,
    busyTimeMinute,
    packageCount,
    verifiedPackageCount
}) => {
    const {t} = useTranslation(["shiftScore", "courierStatuses"]);
    const stores = useStore();

    return (
        <div>
            <p>
                <b>{t("fields.date", {ns: "common"})}</b> : {reportDate}
            </p>
            <p>
                <b>{t("fields.courier", {ns: "common"})}</b> : {fullname}
            </p>
            <p>
                <b>{t("fields.courierIdNo", {ns: "common"})}</b> : {tckn}
            </p>
            <p>
                <b>{t("fields.courierPhone", {ns: "common"})}</b> : {cellPhone}
            </p>
            <p>
                <b>{t("fields.company", {ns: "common"})}</b> : {companyName}
            </p>
            <p>
                <b>{t("fields.subcompany", {ns: "common"})}</b> : {subCompanyName}
            </p>
            <p>
                <b>{t("shiftScore.shiftStartTime", {ns: "shiftScore"})}</b> : {shiftStartTime}
            </p>
            <p>
                <b>{t("shiftScore.shiftEndTime", {ns: "shiftScore"})}</b> : {shiftEndTime}
            </p>
            <p>
                <b>
                    {t("shiftScore.workTime", {ns: "shiftScore"})} - (
                    {t("units.minute.short", {ns: "common"})})
                </b>{" "}
                : {workTimeMinute}
            </p>
            <p>
                <b>
                    {t("shiftScore.workTime", {ns: "shiftScore"})} - (
                    {t("units.hour.long", {ns: "common"})})
                </b>{" "}
                : {minuteToString(workTimeMinute)}
            </p>
            {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                <>
                    <p>
                        <b>
                            {t("shiftScore.busyTimeMinute", {ns: "shiftScore"})} - (
                            {t("units.minute.short", {ns: "common"})})
                        </b>{" "}
                        : {busyTimeMinute > 0 && busyTimeMinute}
                    </p>
                </>
            )}
            <p>
                <b>{t("shiftScore.packageCount", {ns: "shiftScore"})}</b> : {packageCount}
            </p>
            <p>
                <b>{t("shiftScore.verifiedPackageCount", {ns: "shiftScore"})}</b> :{" "}
                {verifiedPackageCount}
            </p>
        </div>
    );
};

export default ShiftScoreDetailModal;
